// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__IO3WA","ranges":"BmiRanges_ranges__dnCKu"};